import { Injectable } from '@angular/core';
import { Vehicle } from '../interfaces/vehicle';
import { RestApiService } from './rest-api.service';

@Injectable({
    providedIn: 'root'
})
export class VehiclesService {

    public vehicles: Array<Vehicle> = [];
    public vehicleCount: number = 0;
    public maxPages: number = 1;
    public pageSize: number = 6;

    constructor(
        private api: RestApiService
    ) { }

    getVehicles(): Promise<any> {
        return new Promise((resolve, reject) => {
            this.api.get('/MI_Galago/WCF_MI_Galago/REST/GetVehiclesVOP', {}, false).then((res) => {
                resolve(res);
            })
        });
    }

    getVehicle(id): Promise<any> {
        return new Promise((resolve, reject) => {
            this.api.get('/MI_Galago/WCF_MI_Galago/REST/vop/vehicle/' + id, {}, true).then((res) => {
                resolve(res);
            });
        });
    }

    getVehiclesAdherent(params): Promise<any> {
        return new Promise((resolve, reject) => {
            this.api.get('/MI_Galago/WCF_MI_Galago/REST/GetVehiclesVOP', params, true).then((res) => {
                resolve(res);
            });
        });
    }

    updateVehicleCount(search?: string): Promise<any> {
        return new Promise((resolve, reject) => {
            let query: any = {};

            if (typeof search === 'string' && search.length > 0) {
                query.search = search;
            }
            this.api.get('/MI_Galago/WCF_MI_Galago/REST/GetVehiclesVOPCount', query, true).then((res) => {
                console.log("VEHICULE PAGE COUNT", res)
                this.vehicleCount = res;
                this.maxPages = Math.ceil(res / this.pageSize);
                if (res <= this.pageSize) {
                    this.maxPages = 0;
                }
                resolve(res);
            });
        });
    }

    setVehicles(vehicles): void {
        this.vehicles = vehicles;
        this.vehicleCount = this.vehicles.length;
    }

    updateVehicle(updatedVehicle): Promise<any> {
        return new Promise((resolve, reject) => {
            this.api.post('/MI_Galago/WCF_MI_Galago/REST/vop/vehicle/update', {
                vehicleVOP: updatedVehicle
            }, false).then((res) => {
                resolve(res);
            });
        });
    };

    updateVehicles(page, search?: string): Promise<any> {
        return new Promise((resolve, reject) => {
            let query: any = {
                page: page,
                pageSize: this.pageSize,
                column: 1,
                sortType: 1
            };

            if (typeof search === 'string' && search.length > 0) {
                query.search = search;
            }

            this.api.get('/MI_Galago/WCF_MI_Galago/REST/GetVehiclesVOP', query, true).then((res) => {
                if (typeof res === 'object' && res.length > 0) {
                    this.setVehicles(res);
                }
                resolve(res);
            });
        });
    }

    command(idEquipment: number, command: string): Promise<any> {
        return new Promise((resolve, reject) => {
            let query: any = {
                idEquipment: idEquipment,
                command: command
            };

            this.api.post('/MI_Galago/WCF_MI_Galago/REST/InsertEquipmentCommand', query, false).then((res) => {
                resolve(res);
            })
        });
    }

    addVehicle(vehicle: { name: string, brand: string, model: string, vehicleFuel?: any, vehicleCategeory?: string, vehicleDetails?: string, idSocietyVop?: number }): Promise<any> {
        return new Promise((resolve, reject) => {
            const query: any = {
                vehicleVopRessource: {
                    name: vehicle.name,
                    mileage: 0,
                    model: vehicle.model,
                    brand: vehicle.brand,
                    vehicleFuel: vehicle.vehicleFuel || 1,
                    vehicleCategeory: vehicle.vehicleCategeory || '',
                    vehicleDetails: vehicle.vehicleDetails || '',
                    idSocietyVop: vehicle.idSocietyVop || 0
                }
            };

            this.api.post('/MI_Galago/WCF_MI_Galago/REST/CreateVehicleVOP', query, false).then((res) => {
                resolve(res);
            });
        });
    }

    getVehicleGPSPoints(id, start, end): Promise<any> {
        return new Promise((resolve, reject) => {
            let query: any = {
                startDate: start,
                endDate: end
            };

            this.api.get(`/MI_Galago/WCF_MI_Galago/REST/vop/vehicle/${id}/pts-gps`, query, true).then((res) => {
                resolve(res);
            })
        });
    }

    activateVehicle(id: number, activate: boolean) {
        return new Promise((resolve, reject) => {
            let action: string = (activate === true) ? 'enable' : 'disable';

            this.api.put(`/MI_Galago/WCF_MI_Galago/REST/vop/vehicle/${id}/activation/${action}`, {}, false).then((res) => {
                resolve(res);
            });
        });
    }
}
